// import { ChevronDown, Code, Minus, Plus, Quote } from 'lucide-react'
import PropTypes from 'prop-types'

import { LinkEditPopover } from '../link/link-edit-popover'
// import { ImageEditDialog } from '../image/image-edit-dialog'
// import { ToolbarSection } from '../toolbar-section'

// const formatActions = [
//   {
//     value: 'codeBlock',
//     label: 'Code block',
//     icon: <Code className="size-5" />,
//     action: (editor) => editor.chain().focus().toggleCodeBlock().run(),
//     isActive: (editor) => editor.isActive('codeBlock'),
//     canExecute: (editor) => editor.can().chain().focus().toggleCodeBlock().run(),
//     shortcuts: ['mod', 'alt', 'C'],
//   },
//   {
//     value: 'blockquote',
//     label: 'Blockquote',
//     icon: <Quote className="size-5" />,
//     action: (editor) => editor.chain().focus().toggleBlockquote().run(),
//     isActive: (editor) => editor.isActive('blockquote'),
//     canExecute: (editor) => editor.can().chain().focus().toggleBlockquote().run(),
//     shortcuts: ['mod', 'shift', 'B'],
//   },
//   {
//     value: 'horizontalRule',
//     label: 'Divider',
//     icon: <Minus className="size-5" />,
//     action: (editor) => editor.chain().focus().setHorizontalRule().run(),
//     isActive: () => false,
//     canExecute: (editor) => editor.can().chain().focus().setHorizontalRule().run(),
//     shortcuts: ['mod', 'alt', '-'],
//   },
// ]

export const SectionFive = ({
  editor,
  // activeActions = formatActions.map((action) => action.value),
  // mainActionCount = 0,
  size,
  variant,
}) => (
  <>
    <LinkEditPopover editor={editor} size={size} variant={variant} />
    {/* <ImageEditDialog editor={editor} size={size} variant={variant} /> */}
    {/* <ToolbarSection
      editor={editor}
      actions={formatActions}
      activeActions={activeActions}
      mainActionCount={mainActionCount}
      dropdownIcon={
        <>
          <Plus className="size-5" />
          <ChevronDown className="size-5" />
        </>
      }
      dropdownTooltip="Insert elements"
      size={size}
      variant={variant}
    /> */}
  </>
)

SectionFive.propTypes = {
  editor: PropTypes.object.isRequired,
  // activeActions: PropTypes.arrayOf(PropTypes.string),
  // mainActionCount: PropTypes.number,
  size: PropTypes.string,
  variant: PropTypes.string,
}

SectionFive.displayName = 'SectionFive'

export default SectionFive
